import React from "react";
import { Navigate } from "react-router-dom";

const WildCardRoute: React.FC = () => {
  const isAuthenticated = !!localStorage.getItem("jwt");

  return isAuthenticated ? <Navigate to="/stores" /> : <Navigate to="/login" />;
};
export default WildCardRoute;
